module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_kawaduzakura_aqua-87ecc8063dbe395947fbcf0f54aa05c3.jpg";